<template>
  <div class="content">
    <ul>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_day_1" name="radio_day" type="radio" value="last_day" v-model="checked" />
          <label for="radio_day_1" class="radio-label" @click="changeLastDay">{{$t('last')}}</label>
        </div>
        <input type="number" v-model="fillterForm.lastDay" @input="changeLastDay" min="1" class="input--tabs" />
        <label>{{ $t('day') }}</label>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_day_2" name="radio_day" type="radio" value="from_day" v-model="checked" />
          <label for="radio_day_2" class="radio-label" @click="changeFormDay"></label>
          <input type="number" min="1" v-model="fillterForm.fromDay" @input="changeFormDay" class="input--tabs" />
          <label>{{ $t('day') }}, {{$t('from')}}</label>
          <select name="day" class="input--tabs" v-model="fillterForm.day" @change="changeFormDay">
            <option v-for="day in listDay" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
          <select name="month" class="input--tabs" v-model="fillterForm.month" @change="createDayByMonth('change')">
            <option v-for="day in listMonth" :key="day.value" :value="day.value">{{ $t(day.name.toLowerCase()) }}</option>
          </select>
          <select name="year" class="input--tabs" v-model="fillterForm.year" @change="createDayByMonth('change')">
            <option v-for="day in listYear" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import listDateTime from '@/constants/dateTime'
import tabType from '@/constants/tabType'
import modeQuery from '@/constants/modeQuery'
import moment from 'moment'
import { datetime } from '@/config'

export default {
  name: 'FilterDay',
  props: {
    activeTab: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: null,
      listDay: [],
      listMonth: listDateTime.month,
      listYear: listDateTime.year,
      fillterForm: {
        lastDay: 4,
        fromDay: 4,
        day: new Date().getDate(),
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      },
      day: {
        createdAtMin: null,
        createdAtMax: null
      },
      listLabel: []
    }
  },
  created () {
    this.createDayByMonth('init')
  },
  methods: {
    changeLastDay () {
      this.checked = tabType.DAY.LAST_DAY
      this.day = {
        createdAtMin: moment()
          .subtract(Number(this.fillterForm.lastDay), datetime.DAY)
          .toJSON(),
        createdAtMax: moment().toJSON()
      }
      this.$emit('changeDay', this.day, modeQuery.DATE, Number(this.fillterForm.lastDay))
    },
    changeFormDay () {
      this.checked = tabType.DAY.FROM_DAY
      const day = Number(this.fillterForm.day) <= 9 ? `0${this.fillterForm.day}` : this.fillterForm.day
      const month = Number(this.fillterForm.month) + 1 <= 9 ? `0${this.fillterForm.month + 1}` : Number(this.fillterForm.month) + 1
      const year = this.fillterForm.year
      const date = new Date(`${year}-${month}-${day}`)
      this.day = {
        createdAtMin: moment(date).toJSON(),
        createdAtMax: moment(date)
          .add(this.fillterForm.fromDay, datetime.DAY)
          .toJSON()
      }
      this.$emit('changeDay', this.day, modeQuery.DATE, Number(this.fillterForm.fromDay), moment().unix(), moment(this.day.createdAtMax).unix())
    },
    createDayByMonth (type) {
      const month = this.fillterForm.month
      const year = this.fillterForm.year
      const date = new Date(year, month, 1)
      let list = []
      while (date.getMonth() === month) {
        list = [...list, { value: new Date(date).getDate(), name: new Date(date).getDate() }]
        date.setDate(date.getDate() + 1)
      }
      this.listDay = list
      if (type === 'change') {
        this.changeFormDay()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  ul {
    padding: 10px;
  }
  .radio-btn {
    padding-bottom: 10px;
    margin: 0.5rem;
    display: flex;
    align-items: center;
    align-content: center;
  }
  .radio {
    display: flex;
    align-items: baseline;
  }
  label {
    color: #a0a8b4;
  }
  .input--tabs {
    margin: 0 8px;
    height: 32px;
    background-image: none;
    border: 1px solid #ccc;
    width: 70px;
    outline: none;
  }
}
</style>
